import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

interface ResponsiveVideoProps {
  embedUrl: string;
  title: string;
}

// Le ratio est tenu par le rembourrage en pourcentage plutôt que par `aspect-ratio` : la propriété
// n'existe pas dans les navigateurs que ce site sert encore, et la technique est sans dépendance.
const useStyles = makeStyles({
  frame: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%',
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: '#000',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 0,
  },
});

const ResponsiveVideo: React.FC<ResponsiveVideoProps> = ({ embedUrl, title }) => {
  const classes = useStyles();

  return (
    <div className={classes.frame}>
      <iframe
        className={classes.iframe}
        title={title}
        src={embedUrl}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default ResponsiveVideo;
